import { PlatformPage } from './PlatformPage'
import { platformFeatures } from '@/data/platform'

export default function Security() {
  return <PlatformPage feature={platformFeatures['security']!} />
}
